<template>
  <m-base>
    <div class="content">
      <div class="reach">
        <div><h1 class="title">Order History</h1></div>
        <div>Manage your recent orders and invoices.</div>
        <b-tabs
          active-nav-item-class="font-weight-bold text-primary"
          content-class="mt-3"
        >
          <b-tab title="Lists/Leads" @click="tabClick(-1)" active>
            <m-order-history />
          </b-tab>
          <b-tab title="Clean List" @click="tabClick(0)">
            <m-ma-order-history :orderType="0" />
          </b-tab>
          <b-tab title="Enhance List" @click="tabClick(1)"
            ><m-ma-order-history :orderType="1" /></b-tab
          >
          <b-tab title="Portrait Reports" @click="tabClick(2)"
            ><m-ma-order-history :orderType="2" /></b-tab
          >
          <b-tab title="Email List" @click="tabClick(3)"
            ><m-ma-order-history :orderType="3" /></b-tab
          >
          <b-tab title="Phone Append" @click="tabClick(5)"
            ><m-ma-order-history :orderType="5" /></b-tab
          >
          <b-tab title="Phone Verification" @click="tabClick(6)"
            ><m-ma-order-history :orderType="6" /></b-tab
          >
          <b-tab title="Reverse Email" @click="tabClick(8)"
            ><m-ma-order-history :orderType="8" /></b-tab
          >
        </b-tabs>
      </div>
    </div>
  </m-base>
</template>

<script>
import MBase from "@/components/layouts/MBase";
import MMaOrderHistory from "@/components/orderHistory/MMaOrderHistory";
import MOrderHistory from "@/components/orderHistory/MOrderHistory";
import utils from "@/assets/utils";

export default {
  components: {
    MBase,
    MMaOrderHistory,
    MOrderHistory
  },
  data() {
    return {
      tabType: -1,
    };
  },
  computed: {},
  created() {},
  methods: {
    tabClick(val) {
      this.tabType = val;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  text-align: center;
  font-weight: bold;
  color: black;
}
.content {
  display: flex;
  justify-content: center;
  background: white;
}
.reach {
  width: 90%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}
.left-title {
  text-align: left;
}
.right-title {
  text-align: right;
}

.search-text {
  max-width: 500px;
}
.account-select {
  max-width: 200px;
}
.text-danger {
  color: $color-primary !important;
}
.page-class.page-link {
  color: $color-primary !important;
}
.pageinfo {
  font-size: 1.1rem;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/OrderHistory.vue